import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { City, Country, State } from "country-state-city";
import SettingSearchLocationByInputStudent from "../../../Institute/AddInstructor/Components/InstructorInfo/components/GooglePlacesApi/SettingSearchLocationByInputStudent";
import { SettingSelectList } from "../../../../Components/InputComps/InputComps";
import { CountryOptions } from "../../../Institute/AddInstructor/Components/OptionsArr/OptionsArr";
import axios from "axios";

const PartnerRegisteration = ({setOpenSignupScreen, InstituteData, setInstituteData}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const [emailError, setEmailError] = useState("");
    const [errors, setErrors] = useState({});
    const [cities, setCities] = useState([]);
    const [SelectedCoordinates, setSelectedCoordinates] = useState(null);
    // console.log(" API_KEY from process.env.REACT_APP_GOOGLE_MAPS_KEY is:",process.env.REACT_APP_GOOGLE_MAPS_KEY);


    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateEmailField = (e, fieldName) => {
    const value = e.target.value;
    // Update the field in the partnerData
    setInstituteData((prev) => ({
        ...prev,
        partnerData: {
        ...prev.partnerData,
        [fieldName]: value,
        },
    }));

    // Validate the email and update errors
    setErrors((prev) => ({
        ...prev,
        [fieldName]: emailRegex.test(value) ? "" : "Invalid email format",
    }));
    };

    // const handleFileChange = (e, field) => {
    //     const file = e.target.files[0];
    
    //     if (file) {
    //         // Generate short name: fieldname_timestamp.ext
    //         const timestamp = Date.now();
    //         const fileExtension = file.name.split('.').pop(); // Get file extension
    //         const shortFileName = `${field}_${timestamp}.${fileExtension}`;
    
    //         // Read file as base64 for preview
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setInstituteData((prev) => ({
    //                 ...prev,
    //                 partnerData: {
    //                     ...prev.partnerData,
    //                     [field]: {
    //                         file, // Store actual file object for upload
    //                         preview: reader.result, // Store base64 for preview
    //                         name: shortFileName, // Store short name for backend
    //                     },
    //                 },
    //             }));
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleFileChange = (event, field) => {
        const file = event.target.files[0]; // Get the selected file
        if (!file) return; // Exit if no file is selected
    
        // Create a preview URL for display
        const previewURL = URL.createObjectURL(file);
    
        // Update state to store both the file and the preview URL
        setInstituteData((prevState) => {
            const newState = { ...prevState };
    
            if (field in prevState.partnerData) {
                newState.partnerData[field] = {
                    file, // Store the actual file for upload
                    previewURL // Store the preview URL for frontend display
                };
            } else if (field in prevState.ownersData) {
                newState.ownersData[field] = {
                    file,
                    previewURL
                };
            }
    
            return newState;
        });
    };
    
    
    // const handleFileChange = (e, field) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setInstituteData((prev) => ({
    //                 ...prev,
    //                 partnerData: {
    //                     ...prev.partnerData,
    //                     [field]: reader.result, // Save base64 preview
    //                 },
    //             }));
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };  

    const validatePhoneNumber = (value, field, country) => {
        const newErrors = { ...errors };
    
        let formattedValue = value.replace(/[^\d]/g, ''); // remove non-digits
    
        // Ensure +1 for US/Canada
        if (country?.dialCode === "1" && !formattedValue.startsWith("1")) {
            formattedValue = "1" + formattedValue;
        }
        if (country?.dialCode === "1") {
            formattedValue = "+" + formattedValue;
        }
    
        const countryCode = country?.dialCode;
    
        // Validate only for US/Canada
        if (countryCode === "1") {
            if (!/^\+1\d{10}$/.test(formattedValue)) {
                newErrors[field] = "Invalid Phone Number ";
            } else {
                delete newErrors[field];
            }
        } else {
            delete newErrors[field]; // No validation for other countries
        }
    
        setErrors(newErrors);
        return formattedValue;
    };
    
    // const validatePhoneNumber = (value, field) => {
    //     const newErrors = { ...errors }; // Copy existing errors
    
    //     // Ensure number starts with +1
    //     let formattedValue = value.startsWith('1') ? `+${value}` : value;
    
    //     // Remove spaces, dashes, and other characters
    //     formattedValue = formattedValue.replace(/[^\d+]/g, '');
    
    //     if (!/^\+1\d{10}$/.test(formattedValue)) {
    //         newErrors[field] = "Invalid Phone number ";
    //     } else {
    //         delete newErrors[field]; // Remove error if valid
    //     }
    
    //     setErrors(newErrors);
    //     return formattedValue; // Store the correctly formatted number
    // };
    
    // Function to update phone number in state and validate
    // const handlePhoneNumberChange = (value, field) => {
    //     const validatedNumber = validatePhoneNumber(value, field);
    //     setInstituteData((prev) => ({
    //         ...prev,
    //         partnerData: { ...prev.partnerData, [field]: validatedNumber },
    //     }));
    // };  
    const handlePhoneNumberChange = (value, field, country) => {
        const validatedNumber = validatePhoneNumber(value, field, country);
        setInstituteData((prev) => ({
            ...prev,
            partnerData: { ...prev.partnerData, [field]: validatedNumber },
        }));
    };
    
    
    
    const handleInputChange = (e, field) => {
        setInstituteData((prev) => ({
            ...prev,
            partnerData: {
                ...prev.partnerData,
                [field]: e.target.value,
            },
        }));
    };

    useEffect(() => {
        const selectedCountry = InstituteData?.partnerData?.country;
        console.log("selected country set in new location is:",selectedCountry)
        const selectedProvince = InstituteData?.partnerData?.province;
        console.log("selected selectedProvince set in new location is:",selectedProvince)
        if (
          typeof selectedCountry === "string" &&
          typeof selectedProvince === "string"
        ) {
          const country = Country?.getAllCountries()?.find(
            (country) =>
              country?.name.toLowerCase() === selectedCountry?.toLowerCase()
          );
          if (country) {
            const states = State?.getStatesOfCountry(country?.isoCode);
            const selectedProvinceData = states?.find(
              (province) =>
                province.name.toLowerCase() === selectedProvince?.toLowerCase()
            );
            if (selectedProvinceData ) {
              console.log("Found Province: ", selectedProvinceData);
              const citiesData = City.getCitiesOfState(
                country?.isoCode,
                selectedProvinceData?.isoCode
              );
              setCities(citiesData);
            }
          }
        }
      }, [InstituteData]);

    const ProvinceOptions = () => {
        let states = [];
    
        // Determine the country to use
      const countryName = InstituteData?.partnerData?.country;
    
        if (typeof countryName  === "string") {
          let countries = Country?.getAllCountries();
    
          const country = countries?.find(
            (country) =>
              country?.name.toLowerCase() ===
              countryName.toLowerCase()
          );
    
          if (country) {
            states = State?.getStatesOfCountry(country?.isoCode);
            // console.log("country", states);
          }
        }
    
        console.log("States", states);
        return states?.map((country) => (
          <option value={country.name} key={country.isoCode}>
            {country?.name}
          </option>
        ));
      };

    const CityOptions = () => {
    return (
        cities &&
        cities?.map((city, index) => (
        <option value={city?.name} key={index}>
            {city?.name}
        </option>
        ))
    );
    };

    const fetchLocationData = async (postalCode) => {
        try {
            console.log("Fetching data for postal code:", postalCode);
            const response = await axios.get(
                "https://maps.googleapis.com/maps/api/geocode/json",
                {
                    params: {
                        address: postalCode,
                        // key: "AIzaSyCWiF-rhJC5vG-_6akKZbSiJ1AIRxJe_mI", // Use your actual API key
                        key: process.env.REACT_APP_GOOGLE_MAPS_KEY,
                    },
                }
            );
    
            if (response.data.results.length > 0) {
                const location = response.data.results[0].address_components;
                console.log("Google Maps API response:", location);
    
                const country = location.find((comp) =>
                    comp.types.includes("country")
                )?.long_name || '';
    
                if (country !== "Canada") {
                    setErrors((prev) => ({ ...prev, postalCode: "Postal code must be from Canada" }));
                    return;
                } else {
                    setErrors((prev) => ({ ...prev, postalCode: "" }));
                }
    
                const state = location.find((comp) =>
                    comp.types.includes("administrative_area_level_1")
                )?.long_name || '';
    
                const city = location.find((comp) =>
                    comp.types.includes("locality")
                )?.long_name || '';
    
                setInstituteData((prev) => ({
                    ...prev,
                    partnerData: {
                        ...prev.partnerData,
                        country,
                        province: state,
                        city,
                    },
                }));
            }
        } catch (error) {
            console.error("Error fetching location data:", error);
            setErrors((prev) => ({ ...prev, postalCode: "Error fetching location data" }));
        }
    };
    
    const handlePostalCodeChange = async (e) => {
        const value = e.target.value.toUpperCase(); // Convert to uppercase for consistency
        const postalCodeRegex = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/; // Canadian postal code format
    
        setInstituteData((prev) => ({
            ...prev,
            partnerData: { ...prev.partnerData, postalCode: value },
        }));
    
        if (!postalCodeRegex.test(value)) {
            setErrors((prev) => ({ ...prev, postalCode: "Invalid Canadian postal code format" }));
            return;
        } else {
            setErrors((prev) => ({ ...prev, postalCode: "" }));
        }
    
        // Fetch location data if postal code is valid
        await fetchLocationData(value);
    };

    // const validateFields = () => {
    //     const newErrors = {};
    //     const { partnerData } = InstituteData;
    
    //     if (!partnerData.logo) newErrors.logo = "required";
    //     if (!partnerData.banner) newErrors.banner = "required";
    //     if (!partnerData.icon) newErrors.icon = "required";
    //     if (!partnerData.businessRegistration) newErrors.businessRegistration = "required";
    //     if (!partnerData.transportationRegistration) newErrors.transportationRegistration = "required";
    //     if (!partnerData.contactNumber) newErrors.contactNumber = "required";
    //     if (!partnerData.emergencyNumber) newErrors.emergencyNumber = "required";
    //     if (!partnerData.emergencyEmail) newErrors.emergencyEmail = "required";
    //     if (!partnerData.email) newErrors.email = "required";
    //     if (!partnerData.businessName) newErrors.businessName = "required";
    //     if (!partnerData.postalCode) newErrors.postalCode = "required";
    //     if (!partnerData.country) newErrors.country = "required";
    //     if (!partnerData.province) newErrors.province = "required";
    //     if (!partnerData.city) newErrors.city = "required";
    //     if (!partnerData.Address) newErrors.Address = "required";
    
    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

    const validateFields = () => {
        const newErrors = {};
        const { partnerData } = InstituteData;
    
        // Check if fields are empty
        if (!partnerData.logo) newErrors.logo = "required";
        if (!partnerData.banner) newErrors.banner = "required";
        if (!partnerData.icon) newErrors.icon = "required";
        if (!partnerData.businessRegistration) newErrors.businessRegistration = "required";
        if (!partnerData.transportationRegistration) newErrors.transportationRegistration = "required";
        if (!partnerData.contactNumber) newErrors.contactNumber = "required";
        if (!partnerData.emergencyNumber) newErrors.emergencyNumber = "required";
        if (!partnerData.emergencyEmail) newErrors.emergencyEmail = "required";
        if (!partnerData.email) newErrors.email = "required";
        if (!partnerData.businessName) newErrors.businessName = "required";
        if (!partnerData.postalCode) newErrors.postalCode = "required";
        if (!partnerData.country) newErrors.country = "required";
        if (!partnerData.province) newErrors.province = "required";
        if (!partnerData.city) newErrors.city = "required";
        if (!partnerData.Address) newErrors.Address = "required";
    
        // Check email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (partnerData.email && !emailRegex.test(partnerData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (partnerData.emergencyEmail && !emailRegex.test(partnerData.emergencyEmail)) {
            newErrors.emergencyEmail = "Invalid email format";
        }
    
        // Check phone format
        // const phoneRegex = /^\+1\d{10}$/;
        // if (partnerData.contactNumber && !phoneRegex.test(partnerData.contactNumber)) {
        //     newErrors.contactNumber = "Invalid phone number";
        // }
        // if (partnerData.emergencyNumber && !phoneRegex.test(partnerData.emergencyNumber)) {
        //     newErrors.emergencyNumber = "Invalid phone number";
        // }

        // Check phone format only for numbers starting with +1
        if (partnerData.contactNumber && partnerData.contactNumber.startsWith("+1")) {
            if (!/^\+1\d{10}$/.test(partnerData.contactNumber)) {
                newErrors.contactNumber = "Invalid Phone Number";
            }
        }

        if (partnerData.emergencyNumber && partnerData.emergencyNumber.startsWith("+1")) {
            if (!/^\+1\d{10}$/.test(partnerData.emergencyNumber)) {
                newErrors.emergencyNumber = "Invalid Phone Number";
            }
        }

    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    

    return (
          <div className="w-full py-[10px] lg:py-[20px] pl-[20px] lg:pl-[40px] pr-[10px] lg:pr-[50px] lg:px-[50px] flex flex-col">
            <p className="mt-[20px] lg:mt-[0px] w-full text-[20px] font-bold  text-[#5f56a8] md:text-[#5f56a8] lg:text-[20px] xl:text-[22px]">
                Partner Registration
            </p>
            <p className="text-[#625BA8] w-[270px] lg:w-full text-[16px]">
                Upload the necessary documents to complete your registration
            </p>
            <div className="w-full flex flex-col lg:flex-row justify-between mt-[10px]">
                <div className="w-full lg:w-[50%] flex flex-col gap-[10px]">
                    <p className="text-[#1D1D1D] text-[22px] font-bold underline">
                        Attachables
                    </p>

                    {errors.businessRegistration && <span className="text-[#FF0000]"> {errors.businessRegistration}</span>}
                    <div className="flex w-full justify-between">
                        <p className="text-[#000000] text-[18px] ">Business Registration Certificate*</p>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                            {InstituteData.partnerData.businessRegistration ? (
                                <img src={InstituteData.partnerData.businessRegistration.previewURL} alt="businessRegistration Preview" className="w-full h-full object-cover rounded-[9px]" />
                            ) : null}
                            </div>
                            <input type="file" accept="image/*" id="businessRegistrationUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "businessRegistration")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("businessRegistrationUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    {errors.transportationRegistration && <span className="text-[#FF0000]"> {errors.transportationRegistration}</span>}
                    <div className="flex w-full justify-between">
                        <p className="text-[#000000] text-[18px] w-[300px]">Ministry of Transportation Registration*</p>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                            {InstituteData.partnerData.transportationRegistration ? (
                                <img src={InstituteData.partnerData.transportationRegistration.previewURL} alt="transportationRegistration Preview" className="w-full h-full object-cover rounded-[9px]" />
                            ) : null}
                            </div>
                            <input type="file" accept="image/*" id="transportationRegistrationUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "transportationRegistration")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("transportationRegistrationUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    {errors.logo && <span className="text-[#FF0000]"> {errors.logo}</span>}
                    <div className="flex w-full justify-between">
                        <p className="text-[#000000] text-[18px] ">Institute Logo*</p>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                            {InstituteData.partnerData.logo ? (
                                <img src={InstituteData.partnerData.logo.previewURL} alt="logo Preview" className="w-full h-full object-cover rounded-[9px]" />
                            ) : null}
                            </div>
                            <input type="file" accept="image/*" id="logoUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "logo")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("logoUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    {errors.banner && <span className="text-[#FF0000]"> {errors.banner}</span>}
                    <div className="flex w-full justify-between">
                        <p className="text-[#000000] text-[18px] ">Institute Banner*</p>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                            {InstituteData.partnerData.banner ? (
                                <img src={InstituteData.partnerData.banner.previewURL} alt="banner Preview" className="w-full h-full object-cover rounded-[9px]" />
                            ) : null}
                            </div>
                            <input type="file" accept="image/*" id="bannerUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "banner")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("bannerUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    {errors.icon && <span className="text-[#FF0000]"> {errors.icon}</span>}
                    <div className="flex w-full justify-between">
                        <p className="text-[#000000] text-[18px] ">Institute Icon*</p>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                            {InstituteData.partnerData.icon ? (
                                <img src={InstituteData.partnerData.icon.previewURL} alt="icon Preview" className="w-full h-full object-cover rounded-[9px]" />
                            ) : null}
                            </div>
                            <input type="file" accept="image/*" id="iconUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "icon")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("iconUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    <p className="text-[#1D1D1D] mt-[15px] lg:mt-[0px] text-[22px] font-bold underline">
                        Contact Information
                    </p>

                    {/* Phone Number */}
                    <div className="flex flex-col gap-[5px] mt-[10px]">
                        <div className="flex w-full justify-between">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                     Institute Contact Number*
                                </label>
                                {errors.contactNumber && <span className="text-[#FF0000]"> {errors.contactNumber}</span>}
                        </div>

                        <PhoneInput  // library to automatically show the country phone code  
                            country="ca" // Automatically sets the country code
                            value={InstituteData.partnerData.contactNumber}
                            // onChange={(value) => handlePhoneNumberChange(value, "contactNumber")}
                            onChange={(value, country) => handlePhoneNumberChange(value, "contactNumber", country)}
                            inputProps={{
                            name: "PhoneNumber",
                            }}
                            containerClass={"PhoneNumberInput"}
                            inputClass={"CustomPhoneNumberInput"}
                            specialLabel={"Phone Number *"}
                            inputStyle={{
                            width: "100%",
                            height: "45px",
                            }}
                        />
                    </div>

                    {/* Emergency Contact Number */}
                    <div className="flex flex-col gap-[5px] mt-[10px]">
                        <div className="flex w-full justify-between">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                     Emergency Contact Number*
                                </label>
                                {errors.emergencyNumber && <span className="text-[#FF0000]"> {errors.emergencyNumber}</span>}
                        </div>
                        <PhoneInput  // library to automatically show the country phone code  
                            country="ca" // Automatically sets the country code
                            value={InstituteData.partnerData.emergencyNumber} 
                            // onChange={(value) => handlePhoneNumberChange(value, "emergencyNumber")}
                            onChange={(value, country) => handlePhoneNumberChange(value, "emergencyNumber", country)}
                            // onChange={(value) => 
                            //     setInstituteData((prev) => ({
                            //         ...prev,
                            //         partnerData: { 
                            //             ...prev.partnerData, 
                            //             emergencyNumber: value ?? ""  // Prevents undefined errors
                            //         }
                            //     }))
                            // }
                            inputProps={{
                            name: "PhoneNumber",
                            }}
                            containerClass={"PhoneNumberInput"}
                            inputClass={"CustomPhoneNumberInput"}
                            specialLabel={"Phone Number *"}
                            inputStyle={{
                            width: "100%",
                            height: "45px",
                            }}
                        />
                    </div>

                     {/* Emergency Email Address */}
                     <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                    Emergency Email Address*
                                </label>
                                {(errors.emergencyEmail || emailError) && <span className="text-[#FF0000]"> {errors.emergencyEmail || emailError} </span>}
                            </div>
                            <input type="text" name="Email" placeholder="abc@gmail.com"
                                value={InstituteData.partnerData.emergencyEmail}
                                // onChange={validateEmail}
                                onChange={(e) => validateEmailField(e, "emergencyEmail")}
                                className="w-full rounded-md py-2 px-[10px] border shadow-md" />
                     </div>
                </div>

                <div className="w-full lg:w-[45%] flex flex-col justify-between gap-[10px]">
                    <div className="w-full flex flex-col gap-[15px] mt-[20px] lg:mt-[0px]">
                        <p className="text-[#1D1D1D] text-[22px] font-bold underline">
                            Institute Information
                        </p>

                        {/* Email Address */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="Email" className="text-[#000000] text-[16px]">
                                    Enter Email*
                                </label>
                                {errors.email && <span className="text-[#FF0000]">{errors.email}</span>}
                            </div>
                            <input
                                type="email"
                                id="Email"
                                name="email"
                                placeholder="abc@gmail.com"
                                value={InstituteData.partnerData.email}
                                onChange={(e) => validateEmailField(e, "email")}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            />
                        </div>

                        {/* Website (if any) */}
                        <div className="flex flex-col gap-[5px]">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                Website (if any)
                                </label>
                                <input
                                    type="text"
                                    id="website"
                                    name="website"
                                    placeholder="Website address here"
                                    value={InstituteData.partnerData.website}
                                    onChange={(e) => handleInputChange(e, "website")}
                                    className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                                />
                        </div>

                        {/* Business Name */}
                        <div className="w-full flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="businessName" className="text-[#000000] text-[16px]">
                                    Business Name*
                                </label>
                                {errors.businessName && <span className="text-[#FF0000]">{errors.businessName}</span>}
                            </div>
                            <input
                                type="text"
                                id="businessName"
                                name="businessName"
                                placeholder="Business Name"
                                maxLength={50} // Limits the input to 50 characters
                                value={InstituteData.partnerData.businessName}
                                onChange={(e) => handleInputChange(e, "businessName")}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            />
                             {/* Character Counter */}
                            <p className="text-[#625BA8] text-[12px] text-right">
                                {InstituteData.partnerData.businessName.length}/50
                            </p>
                        </div>

                        {/* Postal Code */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="postalCode" className="text-[#000000] text-[16px]">
                                    Postal Code*
                                </label>
                                {errors.postalCode && <span className="text-[#FF0000]">{errors.postalCode}</span>}
                            </div>
                            <input
                                type="text"
                                id="postalCode"
                                name="postalCode"
                                placeholder="A1A 1A1"
                                value={InstituteData.partnerData.postalCode}
                                onChange={handlePostalCodeChange}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            />
                        </div>

                        {/* Country */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="country" className="text-[#000000] text-[16px]">
                                    Country*
                                </label>
                                {errors.country && <span className="text-[#FF0000]">{errors.country}</span>}
                            </div>
                            <SettingSelectList
                                Id="Country"
                                defaultValue=""
                                Text="Country"
                                OptionsArr={CountryOptions}
                                State={InstituteData.partnerData.country}
                                onChange={(e) => handleInputChange(e, "country")}
                            />
                            {/* <input
                                type="text"
                                id="country"
                                name="country"
                                placeholder="Canada"
                                value={InstituteData.partnerData.country}
                                onChange={(e) => handleInputChange(e, "country")}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            /> */}
                        </div>

                        <div className="w-full flex gap-[10px]">
                            {/* Province */}
                            <div className="w-[50%] flex flex-col gap-[5px]">
                                <div className="flex w-full justify-between">
                                    <label htmlFor="province" className="text-[#000000] text-[16px]">
                                        Province*
                                    </label>
                                    {errors.province && <span className="text-[#FF0000]">{errors.province}</span>}
                                </div>
                                <SettingSelectList
                                    Id="Province"
                                    defaultValue=""
                                    Text="Province / Territory"
                                    OptionsArr={ProvinceOptions}
                                    State={InstituteData.partnerData.province}
                                    onChange={(e) => handleInputChange(e, "province")}
                                />
                                {/* <input
                                    type="text"
                                    id="province"
                                    name="province"
                                    placeholder="Province"
                                    value={InstituteData.partnerData.province}
                                    onChange={(e) => handleInputChange(e, "province")}
                                    className={`w-[95%] rounded-md py-2 px-[10px] ${Border} shadow-md`}
                                /> */}
                            </div>

                            {/* City */}
                            <div className="w-[50%] flex flex-col gap-[5px]">
                                <div className="flex w-full justify-between">
                                    <label htmlFor="city" className="text-[#000000] text-[16px]">
                                        City*
                                    </label>
                                    {errors.city && <span className="text-[#FF0000]">{errors.city}</span>}
                                </div>
                                <SettingSelectList
                                    Id="City"
                                    defaultValue=""
                                    Text="City"
                                    OptionsArr={CityOptions}
                                    State={InstituteData.partnerData.city}
                                    onChange={(e) => handleInputChange(e, "city")} 
                                />
                                {/* <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    placeholder="City"
                                    value={InstituteData.partnerData.city}
                                    onChange={(e) => handleInputChange(e, "city")}
                                    className={`w-[95%] rounded-md py-2 px-[10px] ${Border} shadow-md`}
                                /> */}
                            </div>
                        </div>

                        {/* Address */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="address" className="text-[#000000] text-[16px]">
                                    Address*
                                </label>
                                {errors.Address && <span className="text-[#FF0000]">{errors.Address}</span>}
                                        </div>
                                        <SettingSearchLocationByInputStudent
                                        InstructorData={{ Address: InstituteData.partnerData.Address }} // Pass Address data
                                        setInstructorData={setInstituteData}
                                        EnrollmentData={{
                                            StudentData: {
                                                Country: InstituteData.partnerData.country, // Use selected country for restrictions
                                            },
                                        }}
                                        setSelectedCoordinates={setSelectedCoordinates} // Update lat/lng
                                        newCountryPostalCode={InstituteData.partnerData.country}
                                        Id="Address"
                                        addressType="Address"
                                        stateKey="partnerData"
                                    />
                            {/* <input
                                type="text"
                                id="address"
                                name="address"
                                placeholder="Address"
                                value={InstituteData.partnerData.Address}
                                onChange={(e) => handleInputChange(e, "Address")}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            /> */}
                        </div>
                    </div>

                    <div
                        className="submit-btn-box-shadow relative  flex w-full justify-center mt-[80px] lg:mt-auto"
                    >
                        <img
                            className="xl-top-[-62px] pointer-events-none absolute   top-[-61px] left-[60%]  w-[103px]  -translate-x-1/2 md:top-[-62px]  lg:top-[-62px] lg:w-[103px] xl:w-[103px]"
                            src={require("./Assets/Sign up Avater.png")}
                            alt=""
                        />
                        <button
                            className={`w-full cursor-pointer rounded-[8px] border-none bg-primary  py-2
                                    text-[16px] text-white  xl:py-2 
                                        xl:text-[18px]     2xl:text-base`}
                                        onClick={() => {
                                        if (validateFields()) {
                                            setOpenSignupScreen("ViewInstituteRegisterationData")
                                        }
                                    }} 
                            // onClick={()=>setOpenSignupScreen("OwnerRegisteration")}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>
          </div>
    );
}

export default PartnerRegisteration;